import { locales } from '@bnb-chain/canonical-bridge-widget';

export const en = {
  ...locales.en.messages,
};
